import { reactive } from "vue";

interface StateStore {
  open: boolean;
  onChange: () => void;
  setRole: (role) => void;
  show: boolean;
  role:string;
}

const stateStore: StateStore = reactive({
  open: false,
  show: true,
  role:'',
  onChange ()  {
    stateStore.open = !stateStore.open
  },
  setRole (role)  {
    stateStore.role = role
  },
})

export default stateStore